export default __webpack_public_path__ + "static/media/FriCo-logo-text.52d29a56.svg";